import BaseService from "./BaseService";
import BaseFilter from './BaseFilter';

export class MessageService extends BaseService {
	constructor() {
		super('/message');
	}

	public getAllByFilter(filter: MessageFilter) {
		return super.getAllByFilterBase(filter);
	}

	public cancelMessage(id: number, data: any) {
		return super.updateBase(this._resourceName + '/CancelMessage/' + id,data);
	}

}

export class MessageFilter extends BaseFilter {
	constructor(idComponentTo?: number | null) {
		super();
		this._idComponentTo = idComponentTo;
	}

	private _idComponentTo?: number | null;
	
	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idComponentTo != null ? { IdComponentTo: this._idComponentTo } : {})
		);

		return data;
	};
}